import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Users2, Building2, Shield, ArrowRight } from 'lucide-react';
import { NavButton } from '../components/NavButton';
import { Card } from '../components/Card';
import { FeatureCard } from '../components/FeatureCard';

export function HomePage() {
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  const cards = [
    {
      title: 'Kongres HDOMST 2026',
      description: 'Godišnji kongres Hrvatskog društva onkoloških medicinskih sestara i tehničara',
      link: '/kongres',
      color: 'from-blue-600 to-blue-800',
      delay: 0.2
    },
    {
      title: 'Tečaj 1. kategorije',
      description: 'Edukacijski tečaj za medicinske sestre i tehničare',
      link: '/tecaj',
      color: 'from-purple-600 to-purple-800',
      delay: 0.4
    },
    {
      title: 'E-Learning',
      description: 'Online edukacijski materijali i tečajevi',
      link: '/e-learning',
      color: 'from-green-600 to-green-800',
      delay: 0.6
    },
    {
      title: 'Simpozij HDOMST 2025',
      description: 'Multidisciplinarni pristup u liječenju tumora probavnih organa',
      link: '/simpozij',
      color: 'from-red-600 to-red-800',
      delay: 0.8
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <motion.h1 
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="text-4xl md:text-5xl font-bold mb-6"
            >
              Hrvatsko Društvo onkoloških medicinskih sestara i tehničara
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto"
            >
              Dobrodošli na službenu stranicu HDOMST-a
            </motion.p>
          </div>
        </div>
      </motion.div>

      {/* Cards Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cards.map((card, index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: card.delay, duration: 0.5 }}
            >
              <Link 
                to={card.link}
                className="block h-full"
              >
                <div className={`h-full bg-gradient-to-br ${card.color} rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl`}>
                  <div className="p-8 text-white">
                    <h2 className="text-2xl font-bold mb-4">{card.title}</h2>
                    <p className="text-lg text-gray-100">{card.description}</p>
                    <div className="mt-6 flex items-center text-gray-100">
                      <span>Saznaj više</span>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <motion.footer 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="bg-gray-50 py-12 mt-16"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-gray-600">
            <p className="mb-2">© 2026 HDOMST - Sva prava pridržana</p>
            <p>Izradio: <a href="http://www.studio-arena.hr" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Studio arena d.o.o.</a></p>
          </div>
        </div>
      </motion.footer>
    </div>
  );
} 